export enum ContentTypes {
  OFFERS = 'common__label--offers',
  DESTINATIONS = 'nav__destinations',
  DESTINATIONS_BY_TRIP_TYPE = 'nav__destinations--trip-type',
  DESTINATIONS_LISTED_ALPHABETICALLY = 'nav__destinations--alphabetically',
  HERE_TO_HELP = 'nav__here-to-help',
  AGENTS = 'nav__agents',
  HELP_CENTRE = 'common__label--help'
}
